import { render, staticRenderFns } from "./disabilityCertification.vue?vue&type=template&id=43bc9760&scoped=true&"
import script from "./disabilityCertification.vue?vue&type=script&lang=ts&"
export * from "./disabilityCertification.vue?vue&type=script&lang=ts&"
import style0 from "./disabilityCertification.vue?vue&type=style&index=0&id=43bc9760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bc9760",
  null
  
)

export default component.exports